import {
  allStatesOfCauseVariableHaveTheSameDirectionChangeDescription,
  defaultRequirementsDescription,
  distinguishedStateMismatchDescription,
  effectHasHigherProbabilityThanCausesDescription,
  tooSmallImpactOfCausesDescription,
  nearestObservableFaultPairsMissingDescription,
  nodesWithoutAssumptionDescription,
  nodesWithoutOptimalStateDescription,
  noisyMaxNodesWithHugeLeakDescription,
  noisyNodesWhereParentStateHasMinimalEffectDescription,
  optimalStateHasABadImpactAllNodePairsDescription,
  optimalStateHasABadImpactParentChildrenPairsDescription,
  assumptionSetExistsButNoCommonCauseDescription,
  wchgAndPchgDirectionNotEqualDescription,
} from '@/services/networkReport/constants'
import {
  ReportOptions,
  WarningOptions,
} from '@/services/networkReport/models/reportOptions'

export function areAllOptionsSelected(options: ReportOptions): boolean {
  return Object.entries(options).every(([key, value]) => {
    if (key === 'warnings') {
      return Object.values(value as WarningOptions).every(Boolean)
    }
    return Boolean(value)
  })
}

function updateWarningOptions(
  warnings: WarningOptions,
  newState: boolean,
): WarningOptions {
  return Object.keys(warnings).reduce((acc, key) => {
    acc[key as keyof WarningOptions] = newState
    return acc
  }, {} as WarningOptions)
}

export function handleWarningOptionChange(
  setOptions: (
    value: ((prevState: ReportOptions) => ReportOptions) | ReportOptions,
  ) => void,
) {
  setOptions((prevOptions) => {
    const allWarningsChecked = Object.values(prevOptions.warnings).every(
      Boolean,
    )
    const newWarningState = !allWarningsChecked

    return {
      ...prevOptions,
      warnings: updateWarningOptions(prevOptions.warnings, newWarningState),
    }
  })
}

export function generateNewOptions(
  currentOptions: ReportOptions,
  newState: boolean,
): ReportOptions {
  return {
    statistics: newState,
    hashtags: newState,
    warnings: updateWarningOptions(currentOptions.warnings, newState),
  }
}

export const getWarningDescription = (key: string): string | undefined => {
  switch (key) {
    case 'effectHasHigherProbabilityThanCauses':
      return effectHasHigherProbabilityThanCausesDescription
    case 'nodesWithoutOptimalState':
      return nodesWithoutOptimalStateDescription
    case 'noisyMaxNodesWithHugeLeak':
      return noisyMaxNodesWithHugeLeakDescription
    case 'noisyNodesWhereParentStateHasMinimalEffect':
      return noisyNodesWhereParentStateHasMinimalEffectDescription
    case 'distinguishedStateMismatch':
      return distinguishedStateMismatchDescription
    case 'optimalStateHasABadImpactAllNodePairs':
      return optimalStateHasABadImpactAllNodePairsDescription
    case 'optimalStateHasABadImpactParentChildrenPairs':
      return optimalStateHasABadImpactParentChildrenPairsDescription
    case 'WCHGAndPCHGWarnings':
      return wchgAndPchgDirectionNotEqualDescription
    case 'allStatesOfCauseVariableHaveTheSameDirectionChange':
      return allStatesOfCauseVariableHaveTheSameDirectionChangeDescription
    case 'assumptionSetExistsButNoCommonCause':
      return assumptionSetExistsButNoCommonCauseDescription
    case 'nearestObservableFaultPairsMissing':
      return nearestObservableFaultPairsMissingDescription
    case 'nodesWithoutAssumption':
      return nodesWithoutAssumptionDescription
    case 'defaultRequirements':
      return defaultRequirementsDescription
    case 'tooSmallImpactOfCauses':
      return tooSmallImpactOfCausesDescription
    default:
      return 'See report error description for more information'
  }
}
